import checkSentenceAccepted from './checkSentenceAccepted';
import getAgreementSentence from './getAgreementSentence';

const getSentenceChanges = (
  section,
  agreement,
  dealChanges,
  invites,
  dealUsers
) => {
  const sentenceChanges = [];

  let acceptedStatus = getAgreementSentence(section, agreement);

  dealChanges.forEach((dealChange) => {
    if (dealChange.type === 'agreement-text-sentence') {
      const changes = JSON.parse(dealChange.changes);
      if (changes && changes.sentence) {
        const changesSection = changes.sentence.section.replace(/\s/g, '');
        if (
          changesSection === section ||
          changesSection === `${section}title`
        ) {
          const acceptedChange = checkSentenceAccepted(
            changes.sentence,
            dealChange.user,
            invites,
            dealUsers
          );
          if (acceptedChange) {
            acceptedStatus = true;
          } else {
            sentenceChanges.push({
              id: dealChange.id,
              changes: changes.sentence,
              user: dealChange.user,
            });
          }
        }
      }
    }
  });

  return { sentenceChanges, acceptedStatus };
};

export default getSentenceChanges;



// WEBPACK FOOTER //
// src/components/Deals/DealEditPages/helpers/getSentenceChanges.js